import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGas = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 40.000000 40.000000",
	preserveAspectRatio: "xMidYMid meet",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(0.000000,40.000000) scale(0.100000,-0.100000)",
		fill: "currentColor",
		stroke: "none",
		children: [/* @__PURE__ */ _jsx("path", { d: "M65 391 c-11 -5 -29 -19 -40 -31 -18 -20 -20 -36 -20 -161 0 -138 0 -139 28 -166 27 -28 28 -28 167 -28 139 0 140 0 167 28 28 27 28 28 28 167 0 139 0 140 -28 167 -27 27 -30 28 -155 30 -70 2 -136 -1 -147 -6z m263 -117 c23 -16 29 -48 12 -59 -7 -4 -7 -12 0 -25 16 -30 12 -48 -15 -66 -21 -14 -31 -15 -51 -5 -32 14 -26 37 9 33 33 -4 38 23 7 33 -11 3 -20 11 -20 17 0 5 9 12 20 15 31 8 26 36 -5 31 -32 -7 -44 11 -20 29 24 17 36 17 63 -3z m-198 -9 c0 -8 -9 -15 -20 -15 -18 0 -20 -7 -20 -65 0 -58 -2 -65 -20 -65 -18 0 -20 7 -20 80 l0 80 40 0 c29 0 40 -4 40 -15z m89 -47 c7 -35 14 -71 17 -80 4 -13 0 -18 -15 -18 -12 0 -21 5 -21 10 0 6 -7 10 -15 10 -8 0 -15 -4 -15 -10 0 -5 -9 -10 -20 -10 -24 0 -24 3 -4 91 14 61 18 69 39 69 20 0 24 -7 34 -62z" }), /* @__PURE__ */ _jsx("path", { d: "M178 205 c-3 -14 -1 -25 3 -25 5 0 9 11 9 25 0 14 -2 25 -4 25 -2 0 -6 -11 -8 -25z" })]
	})
});
export default SvgGas;
